import {Core, NodeSingular} from 'cytoscape';
import { DefaultValues } from '@maporium-workspace/shared';

export const DOUBLE_TAP_SETTINGS_KEY = 'doubleTap';

// Global flag to track double-tap detection state
let isDoubleTapDetectionActive = false;

export function doubleTapExtension(cy: Core, {options}: { options: { doubleTapDelay: number } }) {
  const doubleTapDelay = options.doubleTapDelay || DefaultValues.doubleTapDelay; // Adjust the delay as needed

  let tappedBefore: NodeSingular | null = null;
  let tappedTimeout: ReturnType<typeof setTimeout> | null = null;

  cy.on('tap', (event) => {
    const target = event.target;

    if (tappedTimeout && tappedBefore === target) {
      // Double-tap detected
      clearTimeout(tappedTimeout);
      tappedTimeout = null;
      tappedBefore = null;

      isDoubleTapDetectionActive = true;
      target.emit('doubleTap', event);

      // Reset flag after we finish handling the double tap
      const clearFlag = () => {
        isDoubleTapDetectionActive = false;
      };
      if (typeof queueMicrotask === 'function') {
        queueMicrotask(clearFlag);
      } else {
        Promise.resolve().then(clearFlag);
      }
    } else {
      // First tap - start / restart detection window
      if (tappedTimeout) {
        clearTimeout(tappedTimeout);
      }

      tappedBefore = target;
      isDoubleTapDetectionActive = false;
      tappedTimeout = setTimeout(() => {
        tappedBefore = null;
        tappedTimeout = null;
        isDoubleTapDetectionActive = false;
      }, doubleTapDelay);
    }
  });
}

export function setDoubleTapSetting(value: number) {
  localStorage.setItem(DOUBLE_TAP_SETTINGS_KEY, value.toString());
}

export function getDoubleTapSetting() {
  return parseInt(localStorage.getItem(DOUBLE_TAP_SETTINGS_KEY) || DefaultValues.doubleTapDelay.toString());
}

export function isDoubleTapInProgress() {
  return isDoubleTapDetectionActive;
}
